import { render, staticRenderFns } from "./SelectYourPolicy.vue?vue&type=template&id=7a010237&scoped=true&"
import script from "./SelectYourPolicy.vue?vue&type=script&lang=js&"
export * from "./SelectYourPolicy.vue?vue&type=script&lang=js&"
import style0 from "./SelectYourPolicy.vue?vue&type=style&index=0&id=7a010237&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a010237",
  null
  
)

export default component.exports